module.exports = __webpack_public_path__ + "img/xiangjin1.30be20d9.png";